/**
 * Created by rhinov15 on 05/02/2016.
 *
 * Functionnality chip edition (addition, movement delete). This is linked to secondary room functionalities)
 */

import { ActionState, ActionStateEnum, IdleConstruction, IdleDecoration } from "..";
import { RoomNode } from "../../plan/EntityNodes/RoomNode";
import { Utils } from "../../utils/Utils";
import { EntityManager } from "../../plan/EntityManager";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { Entity, Events, eventsManager, FunctionalityChip, math, Room, SavaneConstants } from "@rhinov/savane-js";

declare var cc: any;


export class MoveFunctionalityChipState extends ActionState {

    // Store state name from global enum
    state: number = ActionStateEnum.MoveFunctionalityChipState;
    lastCursorPosition: math.vec3;
    chip: FunctionalityChip;
    fromConstruction: boolean;
    roomNode: RoomNode;
    // Have we dragged the functionnality chip (no for the moment)
    _dragging: boolean = false;
    savedPosition: math.vec3 | null = null;

    constructor(room: Room, chip: FunctionalityChip, cursorPosition: math.vec3, fromConstruction: boolean) {
        super();


        // Store editied chip
        this.chip = chip;

        // Store current cursor position for upcoming movement
        this.lastCursorPosition = cursorPosition;

        // Store if we are coming from construction
        this.fromConstruction = fromConstruction;

        // Store room graphic node
        this.roomNode = EntityManager.getInstance().getNode(room) as RoomNode;

        

        // Get functionnality chip node to get the functionnality chip position
        var sprite = Utils.getChildByNameRecursivly(PlanManager.getInstance().scrollWindow.grid, chip.id);
        if (sprite !== null) {
            this.savedPosition = this.chip.position;
        }
        else {
            // No position = new functionnality chip created
            this.savedPosition = null;
        }

        PlanManager.getInstance().updateItemsSelected([this.chip], false, false);
    }

    getAction (): number {
        return this.state;
    }

    // The mouse cursor is being moved
    moveMouseCursor (cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        super.moveMouseCursor(cursorPosition);
        // Check if the mouse has moved, if so we have dragged the functionnality chip
        if ((this.lastCursorPosition !== null) && (math.vec3.distance(this.lastCursorPosition, cursorPosition) > SavaneConstants.PositionTolerance)) {
            this._dragging = true;
        }

        // The chip is on the edited plan
        this.chip.isOnPlan = true;

        // Update chip position to new position (the chip is dragged to a new position)
        var position = math.vec3.create();

        math.vec3.set(position, this.chip.position[0] + cursorPosition[0] - this.lastCursorPosition[0], this.chip.position[1] + cursorPosition[1] - this.lastCursorPosition[1], 0);
        // Store and move the chip to the new position
        this.lastCursorPosition = position;
        this.moveSpriteTo(position);

        PlanManager.getInstance().updateItemsSelected([this.chip], false, false);

        return null;
    }

    // Mouse button released
    mouseClickUp (cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        // Only if the entity was moved (i.e. dragged)
        if (this._dragging) {
            // Is the chip position valid ?
            if (this.chip.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
                // Yes, final draw of the functionnality chip
                GameObjectManager.drawFunctionalityChip(this.chip, true, false, this.roomNode);
            }
            else {
                // Cancel functionnality chip movement
                this.cancelMove();
            }

            // Save project in cache
            PlanManager.getInstance().saveInCache();
        }
        else {
            // Open tulip for the functionality chip if coming from decoration
            if (!this.fromConstruction) {
                PlanManager.getInstance().updateItemsSelected([this.chip], true, mouseButton === 2);
            }
            else {
                PlanManager.getInstance().updateItemsSelected([this.chip], false, false);
            }
        }

        // Go back to IdleConstruction or IdleDecoration state
        if (this.fromConstruction) {
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction(this.chip);
        }
        else {
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.idleDecoration);
            return new IdleDecoration();
        }
    }

    // Right mouse button pressed (cancel)
    mouseClickCancelled (cursorPosition: math.vec3): ActionState | null {
        // Cancel functionnality chip movement
        this.cancelMove();

        // Save project in cache
        PlanManager.getInstance().saveInCache();

        // Go back to IdleConstruction or IdleDecoration state
        if (this.fromConstruction) {
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction(this.chip);
        }
        else {
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.idleDecoration);
            return new IdleDecoration();
        }
    }

    // Cancel functionnality chip movement
    cancelMove () {
        // Check if the chip was edited or created
        if (this.savedPosition === null) {
            // Creation, delete the functionnality chip
            this.chip.isOnPlan = false;
            GameObjectManager.deleteFunctionalityChip(this.chip);
        }
        else {
            // Edition, move it back to its previous position (before edition)
            this.chip.isOnPlan = true;
            this.moveSpriteTo(this.savedPosition)
        }
    }

    /**
     * Move the sprite to the absolute position
     * @param cursorPosition
     */
    moveSpriteTo (absolutePosition: math.vec3) {
        // Graphic node to attach the chip sprite to
        var nodeToAttach: any = this.roomNode;

        // Move the entity to its new position
        this.chip.position = absolutePosition;
        // Is the chip valid position valid ?
        if (!this.chip.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
            nodeToAttach = PlanManager.getInstance().scrollWindow.grid;
        }
        // Draw the functionnality chip sprite
        GameObjectManager.drawFunctionalityChip(this.chip, this.chip.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!), false, nodeToAttach);
    }

    // Key pressed management
    keyPressed (keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        // Escape just cancel the current operation
        if (keyCode == cc.KEY.escape) {
            return (this.mouseClickCancelled(math.vec3.create()));
        }

        return null;
    }

    snapClick (): ActionState {
        // Go back to IdleConstruction or IdleDecoration state
        if (this.fromConstruction) {
            return new IdleConstruction();
        }
        else {
            return new IdleDecoration();
        }
    }

    isDecorationState (): boolean {
        return (!this.fromConstruction);
    }

    dispose () {
        //TODO Remove sprite
    }
}
